/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a true-to-life ruler, hold a credit or ID card against the screen and slide until the outline matches its size. Saved for next time.`)
};

const es_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para una regla fiel a la realidad, apoya una tarjeta de crédito o de identidad contra la pantalla y desliza hasta que el contorno coincida con su tamaño. Se guarda para la próxima vez.`)
};

const de_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für ein originalgetreues Lineal halte eine Kredit- oder Ausweiskarte an den Bildschirm und verschiebe den Regler, bis der Umriss genau passt. Wird für das nächste Mal gespeichert.`)
};

const nl_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor een levensechte liniaal houd je een bank- of ID-kaart tegen het scherm en schuif je totdat de omtrek overeenkomt met de kaart. Wordt onthouden voor de volgende keer.`)
};

const fr_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour une règle fidèle à la réalité, tenez une carte bancaire ou d'identité contre l'écran et faites glisser jusqu'à ce que le contour corresponde à sa taille. Enregistré pour la prochaine fois.`)
};

const it_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per un righello davvero fedele, appoggia una carta di credito o un documento sullo schermo e trascina fino a far coincidere il contorno con la sua misura. Viene salvato per la prossima volta.`)
};

const pt_br2_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para uma régua fiel ao tamanho real, encoste um cartão de crédito ou documento na tela e ajuste até o contorno bater com o tamanho dele. A calibração fica salva para a próxima vez.`)
};

const pt_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para uma régua fiel ao real, encoste um cartão de crédito ou de identificação ao ecrã e deslize até o contorno corresponder ao tamanho do cartão. Fica guardado para a próxima vez.`)
};

const ja_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実物と同じ大きさの定規にするには、クレジットカードやIDカードを画面に当て、輪郭がカードのサイズに合うまでスライドしてください。次回のために保存されます。`)
};

const zh_ruler_calibrate_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为获得逼真的标尺效果，请将银行卡或身份证贴在屏幕上，滑动调整直到轮廓与卡片大小一致。设置会被保存，下次无需重复。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_calibrate_help = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_calibrate_help(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_calibrate_help", locale)
	if (locale === "en") return en_ruler_calibrate_help(inputs)
	if (locale === "es") return es_ruler_calibrate_help(inputs)
	if (locale === "de") return de_ruler_calibrate_help(inputs)
	if (locale === "nl") return nl_ruler_calibrate_help(inputs)
	if (locale === "fr") return fr_ruler_calibrate_help(inputs)
	if (locale === "it") return it_ruler_calibrate_help(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_calibrate_help(inputs)
	if (locale === "pt") return pt_ruler_calibrate_help(inputs)
	if (locale === "ja") return ja_ruler_calibrate_help(inputs)
	return zh_ruler_calibrate_help(inputs)
};